window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-timeline-item").forEach(item => {
    const toggle = item.querySelectorAll(".icon-chevron-down, .c-title");
    const content = item.querySelector(".c-accordion-inner");
    const inner = content?.querySelector(".c-inner");
    if (!toggle || !content || !inner) return;
    toggle.forEach(e => e.addEventListener("click", onToggle, {
      passive: true
    }));
    function onToggle() {
      item.classList.toggle("open");
    }
    window.addEventListener("resize", () => {
      const duration = inner.scrollHeight * 768 / 512;
      content.style.setProperty("--duration", `${duration}ms`);
    });
  });
});